import { useTranslate } from "@similarweb/i18n-provider";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import InfoIconTooltip from "app/pages/sales-intelligence/common-components/tooltip/InfoIconTooltip/InfoIconTooltip";
import type { CrmEnrichmentJobPrice } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";
import solutionUrlsService from "app/pages/sales-intelligence/services/solution-urls";

import { StyledCrmEnrichmentJobReviewCreditsContainer } from "./styles";

type Props = {
    isLoading: boolean;
    priceData?: CrmEnrichmentJobPrice;
};

const CrmEnrichmentJobReviewCredits = ({ priceData, isLoading }: Props) => {
    const { translate } = useTranslate();

    const handleClick = () => {
        const accountLink = solutionUrlsService.getAccountDataCreditsUrl();

        window.open(accountLink, "_blank", "noopener noreferrer");
    };

    return (
        <StyledCrmEnrichmentJobReviewCreditsContainer data-automation="price-container">
            <SWReactIcons
                iconName="revenue-growth"
                size="md"
            />

            <Stack
                gap="4px"
                margin="16px 0 32px"
                alignItems="center"
            >
                {isLoading ? (
                    <PixelPlaceholderLoader
                        height="24px"
                        width="132px"
                    />
                ) : (
                    <Text
                        fontVariant="h6"
                        color={colorsPalettes.carbon[400]}
                    >
                        {translate("si.crm-enrichment.job-wizard.review.credits", { price: priceData?.price })}
                    </Text>
                )}

                <Flex gap="6px">
                    <Text
                        fontVariant="input2"
                        color={colorsPalettes.carbon[300]}
                    >
                        {translate("si.crm-enrichment.job-wizard.review.price")}
                    </Text>

                    <InfoIconTooltip tooltipKey="si.crm-enrichment.job-wizard.review.price.tooltip" />
                </Flex>
            </Stack>

            <Button
                type="flatDark"
                onClick={handleClick}
            >
                {translate("si.crm-enrichment.job-wizard.review.manage-credits")}
            </Button>
        </StyledCrmEnrichmentJobReviewCreditsContainer>
    );
};

export default CrmEnrichmentJobReviewCredits;
